import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "./style/App.css";
import { LayOut } from "./pages/LayOut";
import { LoginPage } from "./pages/LoginPage";
import { PrivateUserAuth } from "./routs/PrivateUserAuth";
import { Company } from "./pages/Company";
import { MyCompanies } from "./pages/MyCompanies";
import { Partners } from "./pages/Partners";
import PartnerCard from "./pages/PartnerCard";
import { Employees } from "./pages/Employees";
// import { NoRight } from "./pages/NoRight";
import { EmploessCard } from "./pages/EmploessCard";
import CompanyCard from "./pages/CompanyCard";
import { UserProfile } from "./pages/UserProfile";
import { AllReport } from "./pages/AllReport";
import { AlertCenter } from "./pages/AlertCenter";
import { AdminPanel } from "./pages/AdminPanel";
import { useEffect } from "react";
import ApiData from "./api/ApiData";
import { observer } from "mobx-react-lite";
import Media from "./api/Media";
import RolesState from "./api/RolesState";
import stateFilter from "./state/state.filter";
import { CheckRight } from "./routs/CheckRight";
import { NoRight } from "./pages/NoRigth";
import { getStoredUser } from "./utils/auth.utils";
import ReportData from "./api/ReportData";
import User from "./api/User";
import config from "./config.json";
import Msg from "./api/Msg";

const App = observer(() => {
  useEffect(() => {
    Media.handlerResize(window.innerWidth);
    const handleResize = (event) => {
      Media.handlerResize(event.target.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const getDataLocalStorage = (name, boolean) => {
      const locatItem = localStorage.getItem(name);
      if (locatItem === null) {
        stateFilter.setLocalStorage(name, boolean);
      } else {
        if (locatItem === "true") {
          stateFilter.setParameter(name, true);
        } else {
          stateFilter.setParameter(name, false);
        }
      }
    };
    getDataLocalStorage("filter_active_client", true);
    getDataLocalStorage("subscription_companies", false);
    getDataLocalStorage("filter_active_server", false);
  }, []);

  useEffect(() => {
    if (!ApiData.isAuth || !getStoredUser()) {
      ApiData.logout();
      navigate("/login", { replace: true });
      return;
    }
    // Проверка версии приложения
    const versionApp = Number(localStorage.getItem("version_app"));
    if (versionApp < config.version_app) {
      ApiData.logout();
      Msg.writeMessages(
        "Версия сайт обновлена. Пожалуйста, авторизуйтесь повторно.",
      );
      localStorage.removeItem("k");
      localStorage.removeItem("at");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      await RolesState.readRight();
      await ApiData.loadMyDashboardCompanies();
      if (
        (RolesState.all_soft_client && RolesState.get_all_licensing) ||
        User.user?.is_superuser
      ) {
        ReportData.warmVersionReportAtStartup();
      }
    })();
  }, [navigate, ApiData.isAuth]);

  return (
    <Routes>
      <Route path="/" element={<LayOut />}>
        <Route index element={<LoginPage />} />
        <Route index path="login" element={<LoginPage />} />
        {ApiData.isAuth ? (
          <Route element={<PrivateUserAuth />}>
            <Route element={<CheckRight />}>
              <Route path="adminpanel" element={<AdminPanel />}></Route>
              <Route path="company" element={<Company />} />
              <Route path="my-companies" element={<MyCompanies />} />
              <Route path="partners" element={<Partners />} />
              <Route path="partners/:inn" element={<PartnerCard />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/:id" element={<EmploessCard />} />
              <Route path="company/:inn" element={<CompanyCard />} />
              <Route path="profile" element={<UserProfile />} />
              <Route path="allreport" element={<AllReport />} />
              <Route path="alertcenter" element={<AlertCenter />} />
            </Route>
            <Route path="noright" element={<NoRight />} />
            <Route
              path="norights"
              element={<Navigate to="/noright" replace />}
            />
          </Route>
        ) : (
          <Route index path="login" element={<LoginPage />} />
        )}
      </Route>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
});

export default App;
